/**
 * To download file from data binary
 *
 * @param {string} url Path to file
 */
export default function download(url, fileName = 'file') {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.target = '_self';
  anchor.download = fileName; // download indicator, suppress browser console warning
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}
